var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorwegianFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 15,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0.5H0V30.5H30V0.5Z",
    fill: "#EF2B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0.5H6.25V30.5H13.75V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11.5H0V19.5H30V11.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 0.5H8.125V30.5H11.875V0.5Z",
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 13.5H0V17.5H30V13.5Z",
    fill: "#002868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorwegianFlag);
export default __webpack_public_path__ + "static/media/norwegianFlag.5361693970da3c49989603809d604551.svg";
export { ForwardRef as ReactComponent };